import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./CompetitorsPageSpeed.css";
import CompetitorsPageSpeedDashboard from "./CompetitorsPageSpeedDashboard/CompetitorsPageSpeedDashboard";
import CompetitorsPageScanRequests from "./CompetitorsPageScanRequests/CompetitorsPageScanRequests";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface CompetitorsPageSpeedProps {
  psiRequestRows: any;
  userToken: string;
  selectedSiteUid: any;
  setRefresh: any;
  refresh: any;
  value: number; // Selected tab index passed from parent
  onTabChange: (newValue: number) => void; // Handler for tab changes
}

const CompetitorsPageSpeedTabs = ({
  psiRequestRows,
  userToken,
  selectedSiteUid,
  setRefresh,
  value,
  onTabChange,
}: CompetitorsPageSpeedProps) => {
  const userData = useSelector(selectUserData);
  const hasViewExternalPsiRequestsPermission =
    CheckPermissions(
      userData?.data?.products?.market_positioning,
      "scout",
      "view_external_psi_requests"
    );
  const hasViewCompetitorPageSpeedDashBoardPermission =
    CheckPermissions(
      userData?.data?.products?.market_positioning,
      "scout",
      "view_external_page_speed_performance"
    );

  const handleChange = (_: unknown, newValue: number) => {
    onTabChange(newValue); // Notify the parent component about the tab change
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            aria-label="basic tabs example"
            sx={{
              "& .MuiTab-root": {
                color: "#00000099", // Default color for unselected tabs
                "&.Mui-selected": {
                  color: "#9C27B0", // Change color when the tab is selected
                },
              },
              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },
              "& .MuiTab-root:first-of-type": {
                paddingLeft: 0,
              },
            }}
          >
            <Tab label="Page Speed Dashboard" {...a11yProps(0)} />
            <Tab label="Page Scan Requests" {...a11yProps(1)} />
          </Tabs>
        </Box>
        {hasViewCompetitorPageSpeedDashBoardPermission ? (
          <CustomTabPanel value={value} index={0}>
            <CompetitorsPageSpeedDashboard
              selectedSiteUid={selectedSiteUid}
              oauthTokenHeader={userToken}
            />
          </CustomTabPanel>
        ) : (
          <Page404 />
        )}
        {hasViewExternalPsiRequestsPermission ? (
          <CustomTabPanel value={value} index={1}>
            <CompetitorsPageScanRequests
              psiRequestRows={psiRequestRows}
              userToken={userToken}
              selectedSiteUid={selectedSiteUid}
              setRefresh={setRefresh}
            />
          </CustomTabPanel>
        ) : (
          <Page404 />
        )}
      </Box>
    </>
  );
};

export default CompetitorsPageSpeedTabs;
